import React from "react";
import PropTypes from "prop-types";

import { userTypes } from "domain/GamesSearch/types";
import PlayersListItem from "components/PlayersDetailing/PlayersList/Item";
import { noop } from "lodash-es";

const PlayersList = ({
    players,
    isOrganizer,
    onRemove,
    needReport,
    isRegular = false,
    isInvate,
    onPlayerClick = noop,
    isFreePlaceInMainList,
    transferPlayerToMainList,
}) => {
    return (
        <div className="players-list">
            {players.map((player) => {
                return (
                    <PlayersListItem
                        key={`player-list-item-${player.id}`}
                        {...player}
                        isRegular={isRegular}
                        isInvate={isInvate}
                        isOrganizer={isOrganizer}
                        onRemove={onRemove}
                        needReport={needReport}
                        onPlayerClick={onPlayerClick}
                        isFreePlaceInMainList={isFreePlaceInMainList}
                        transferPlayerToMainList={transferPlayerToMainList}
                    />
                );
            })}
        </div>
    );
};

PlayersList.propTypes = {
    players: PropTypes.arrayOf(userTypes),
    isOrganizer: PropTypes.bool,
    onRemove: PropTypes.func.isRequired,
    needReport: PropTypes.bool,
    onPlayerClick: PropTypes.func,
    isRegular: PropTypes.bool,
    isInvate: PropTypes.bool,
    isFreePlaceInMainList: PropTypes.bool,
    transferPlayerToMainList: PropTypes.func,
};

export default PlayersList;
